import { HttpStatusCode } from '../../protocols'
import {
  AccessDeniedError,
  UnauthorizedError,
  UnexpectedError
} from '../../../domain/errors'

export class HomeUseCase {
  url
  httpClient

  constructor(url: string, httpClient: any) {
    this.url = url
    this.httpClient = httpClient
  }

  async load() {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get'
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError()
      case HttpStatusCode.ok:
        return httpResponse.body
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError()
      default:
        throw new UnexpectedError()
    }
  }

  async update(body: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      data: body
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError()
      case HttpStatusCode.ok:
        return httpResponse.body
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError()
      case HttpStatusCode.badRequest:
        throw new Error(httpResponse.body.title)
      case 409:
        throw new Error(httpResponse.body.userMessage)
      default:
        throw new UnexpectedError()
    }
  }
}
